export const iconFontAwesomeHumanitarianPeopleGroup = (
	<i className="fa-solid fa-people-group"></i>
);
